import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import withWidth from 'material-ui/utils/withWidth'
import {withStyles} from 'material-ui/styles/index'
import Container from '../../../common/components/Container'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'
import Typography from 'material-ui/Typography'
import {Frame} from '../../../components'
import {faqCategories as text} from '../text'

const FAQ_CATEGORY_IMAGE = '/assets/faqCategory.png'

const styles = theme => ({
  topBanner: {
    marginTop: 0,
    paddingTop: 45,
    paddingBottom: 40,
    background: `linear-gradient(135deg, ${theme.palette.gradient.start} 0%, ${theme.palette.gradient.end} 100%)`,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: -47,
    },
  },
  screenTitle: {
    color: '#FFF',
  },
  title: {
    maxWidth: 500,
    margin: '0 auto',
    color: '#FFF',
  },
  container: {
    paddingTop: 50,
    paddingBottom: 75,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'center',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
    },
  },
  frame: {
    flex: 1,
    maxWidth: 400,
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('lg')]: {
      maxWidth: 'auto',
      margin: 10,
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: 380,
    },
  },
})

class FaqCategories extends React.Component {

  static displayName = 'FaqCategories.component'

  handleClick = (id) => {
    this.props.history.push('/ayuda/faqs/' + id)
  }

  render() {
    const {classes, error, loading, categories} = this.props

    if (error !== '' && error !== undefined) {
      return <ErrorMessage error={error}/>
    }

    return (
      <div>
        <HeaderProgress show={loading}/>
        <div className={classes.topBanner}>
          <Typography variant={'subheading'} className={classes.screenTitle} gutterBottom={true}>
            {text.screenTitle}
          </Typography>
          <Typography variant={'display1'} className={classes.title} gutterBottom={true}>
            {text.title}
          </Typography>
        </div>
        <Container>
          <div className={classes.container}>
            {categories.map(c => (
              <Frame image={FAQ_CATEGORY_IMAGE} imgProps={{style: {width: 32, height: 36}}}
                     className={classes.frame} buttonText={text.button}
                     text={c.Name} description={c.Description}
                     invertImgPosition={true}
                     onClick={() => this.handleClick(c.ID)}
              />
            ))}
          </div>
        </Container>
      </div>
    )
  }

  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    categories: PropTypes.array.isRequired,
  }
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(FaqCategories)



// WEBPACK FOOTER //
// ./src/sections/help/components/faqCategories.js